import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  getAnonCompanyData,
  getLaunchWeekData,
  getScheduleRosterStatusCount,
  postPayrollFirstPayDate,
  postUploadDocument,
  postUploadSchedule,
  subscribeToExperimentalBundle,
} from './api';

export const SLICE_NAME = 'productGrowth';

export const createPayrollFirstPayDate = createAsyncThunk<string, string>(
  `${SLICE_NAME}/createPayrollFirstPayDate`,
  (payload, { rejectWithValue }) =>
    postPayrollFirstPayDate(payload).catch(error =>
      rejectWithValue(error.body || error.message)
    )
);

export const createUploadDocument = createAsyncThunk(
  `${SLICE_NAME}/createUploadDocument`,
  (document: File, { rejectWithValue }) =>
    postUploadDocument(document).catch(error =>
      rejectWithValue(error.body || error.message)
    )
);

export const createUploadSchedule = createAsyncThunk(
  `${SLICE_NAME}/createUploadSchedule`,
  (image: string, { rejectWithValue }) =>
    postUploadSchedule(image).catch(error =>
      rejectWithValue(error.body || error.message)
    )
);

export const fetchScheduleRosterStatusCount = createAsyncThunk(
  `${SLICE_NAME}/fetchScheduleRosterStatusCount`,
  (image: string, { rejectWithValue }) =>
    getScheduleRosterStatusCount().catch(error =>
      rejectWithValue(error.body || error.message)
    )
);

export const fetchDashboardBanner = createAsyncThunk(
  `${SLICE_NAME}/launchWeek`,
  async (_, { rejectWithValue }) =>
    getLaunchWeekData().catch(error =>
      rejectWithValue(error.body || error.message)
    )
);

export const fetchAnonCompanyData = createAsyncThunk(
  `${SLICE_NAME}/fetchAnonCompanyData`,
  async (
    payload: {
      isInSSS?: boolean;
      companyUuid: string;
      extractionProcessId: string;
      step: 'business_details' | 'team_members';
    },
    { rejectWithValue }
  ) =>
    getAnonCompanyData(payload).catch(error =>
      rejectWithValue(error.body || error.message)
    )
);

export const subscribeToBundle = createAsyncThunk(
  `${SLICE_NAME}/subscribeToBundle`,
  async (
    payload: {
      paymentMethodId: string;
      bundleName: string;
    },
    { rejectWithValue }
  ) =>
    subscribeToExperimentalBundle(payload).catch(error =>
      rejectWithValue(error.body || error.message || error.errors)
    )
);
